import React from 'react';
import { Trophy, BarChart3, Network } from 'lucide-react';
import { cn } from '../../lib/utils';

export type MobileTab = 'bracket' | 'standings' | 'simulate';

interface MobileNavProps {
  activeTab: MobileTab;
  onTabChange: (tab: MobileTab) => void;
}

const tabs: { id: MobileTab; label: string; icon: React.ElementType }[] = [
  { id: 'bracket', label: 'Bracket', icon: Network },
  { id: 'standings', label: 'Standings', icon: Trophy },
  { id: 'simulate', label: 'Simulate', icon: BarChart3 },
];

const MobileNav: React.FC<MobileNavProps> = ({ activeTab, onTabChange }) => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 lg:hidden pb-[max(13px,env(safe-area-inset-bottom,0px))]">
      <div className="flex h-14 items-center justify-around">
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => onTabChange(id)}
            className={cn(
              "flex flex-col items-center justify-center gap-0.5 flex-1 h-full text-xs transition-colors",
              activeTab === id
                ? "text-primary font-medium"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            <Icon className="h-5 w-5" />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default MobileNav;
